<template>
  <div id="zj-component-starttasklist" class="zj-emergency-starttask-list select-none">
    <div>采用预案：{{this.planName}}</div>
    <div>
      <div>
        <el-table :data="tableData" :show-header="false" stripe="false">
          <el-table-column>
            <template slot-scope="scope">
              <div class="task-row select-none">
                <div class="task-row-1">
                  <div class="seq">{{scope.$index + 1}}、</div>
                  <div class="detail">{{scope.row.taskName}}</div>
                  <div class="tag" :v-if="scope.row.ExecWay == 1">预案任务</div>
                  <div class="status" :class="statusClass(scope.row.status)">{{ optionsObj[scope.row.status]}}</div>
                </div>
                <div class="task-row-2">
                  <div class="contact">{{scope.row.personIdTranslated}}</div>
                  <div class="phone">{{scope.row.mobileNo}}</div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import Constant from "../config/constant";

//import MyApis from "../../../../apis";

export default {
  name: "ZJEmergencyComponentStartTaskList",
  componentName: "ZJEmergencyComponentStartTaskList",
  components: {},
  props: {
    tableData: Array,
    planName: {
      type: String,
      required: true,
      default: ""
    },
    optionsObj:Object,
  },
  data() {
    return {
      isVisiable: false
    };
  },
  methods: {
    statusClass: function(status) {
      return {
        processing:
          status == 3,
        todo:
          status == 1,
        finished:
          status == 4 || status == 2
      };
    },
  }
};
</script>